import { useState } from 'react'; 
import { useNavigate } from 'react-router-dom';
import { images } from '../../assets/Images/assetsImages';
import InquirySection from '../../components/Admin/InquirySection';
import AtlierDataSection from '../../components/Admin/AtlierDataSection';
import NewsLetterSection from '../../components/Admin/NewsletterSection';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('inquiries');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleLogout = async (err) => {
      err.preventDefault();
      try {
            sessionStorage.removeItem('authToken');
            navigate('/admin');
  
        } catch (error) {
          alert('An error occurred. Please try again..');
        }
    };

  return (
    <div className='w-full h-screen bg-gray-50 font-sans'>
      <div className='w-full h-[10%] flex shadow-md bg-white'>
        <div className='w-[15%] h-full flex justify-center items-center'>
          <img src={images.Logo} alt='Logo' className='w-[60%] h-auto' />
        </div>
        <div className='w-[65%] h-full'></div>
        <div className='w-[20%] h-full flex justify-center items-center'>
          <button
            onClick={handleLogout}
            className='w-[50%] h-[50%] text-white bg-[#6A480A] rounded-lg hover:bg-[#8d692f] hover:border-2 hover:border-[#8d692f] transition-all duration-200 
            font-semibold tracking-wide'>
            Logout
          </button>
        </div>
      </div>

      <div className='w-full flex'>
        <div className='w-[15%] h-screen shadow-lg'>
          <div className="p-5">
            <div 
              className={`flex items-center justify-start w-full h-[60px] p-3 mb-2 rounded-lg cursor-pointer ${
                activeTab === "inquiries" ? "bg-[#6A480A] text-white" : "text-gray-600 hover:bg-gray-200 hover:text-[#6A480A]"
              }`}
              onClick={() => handleTabChange('inquiries')}
            >
              <span className="text-xl font-medium">Customer Inquiries</span>
            </div>
            <div 
              className={`flex items-center justify-start w-full h-[60px] p-3 rounded-lg cursor-pointer ${
                activeTab === "atelier" ? "bg-[#6A480A] text-white" : "text-gray-600 hover:bg-gray-200 hover:text-[#6A480A]"
              }`}
              onClick={() => handleTabChange('atelier')}
            >
              <span className="text-xl font-medium">Atelier Registration</span>
            </div>
            <div 
              className={`flex items-center justify-start w-full h-[60px] p-3 rounded-lg cursor-pointer ${
                activeTab === "newsletter" ? "bg-[#6A480A] text-white" : "text-gray-600 hover:bg-gray-200 hover:text-[#6A480A]"
              }`}
              onClick={() => handleTabChange('newsletter')}
            >
              <span className="text-xl font-medium">Newsletter</span>
            </div>
          </div>
        </div>

        <div className='w-[85%] p-8 bg-gray-100'>
          {activeTab === 'inquiries' && <InquirySection />}
          {activeTab === 'atelier' && <AtlierDataSection />}
          {activeTab === 'newsletter' && <NewsLetterSection />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
